export const ItemTypes = {
  KNIGHT: 'knight'
};


/** WEBPACK FOOTER **
 ** ./examples/00 Chessboard/Tutorial App/Constants.js
 **/